<template>
  <div class="commonDialogBody">
    <el-dialog
        :close-on-click-modal='false'
        title="支付配置"
        :visible.sync="dialogVisible"
        width="85%"
        :destroy-on-close="true"
        :before-close="handleClose">
          <el-dialog
          width="50%"
          :title="innerTitle"
          :visible.sync="innerVisible"
          append-to-body>
        <div class="menuTool" style="width:60%;margin-bottom:30px;">
          <el-form :label-position="labelPosition" label-width="120px" :model="information" style="width:75%;">
              <el-form-item label="支付配置名" >
                <el-input v-model="information.payName" size="small" :disabled="DisabledT"></el-input>
              </el-form-item>
              <el-form-item label="系统ID">
                <el-input v-model="appIdentifier" size="small" disabled></el-input>
              </el-form-item>
              <el-form-item label="支付类型" >
                  <el-select v-model="PaymentTypeValue" placeholder="请选择支付类型" @change="ChangePay(PaymentTypeValue)" :disabled="DisabledTS">
                    <el-option
                      v-for="item in PaymentTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
              </el-form-item>    
              <el-form-item label="业务类型" >
                  <el-select v-model="BusinessTypeValue" placeholder="请选择业务类型" @change="ChangeBus(BusinessTypeValue)" :disabled="DisabledTS">
                    <el-option
                      v-for="item in BusinessTypeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>                
              </el-form-item> 
              <el-form-item label="回调接口" >
                <el-input v-model="information.callbackUrl" size="small" :disabled="DisabledT"></el-input>
              </el-form-item>   
              <el-form-item label="成功回调" >
                <el-input v-model="information.returnUrl" size="small" :disabled="DisabledT"></el-input>
              </el-form-item>      
              <el-form-item label="通知回调" >
                <el-input v-model="information.noticeUrl" size="small" :disabled="DisabledT"></el-input>
              </el-form-item>   
              <el-form-item label="创建时间" v-show="showDis">
                <el-input v-model="information.createTime" size="small" :disabled="DisabledT" ></el-input>
              </el-form-item>      
              <el-form-item label="更新时间" v-show="showDis">
                <el-input v-model="information.updateTime" size="small" :disabled="DisabledT"></el-input>
              </el-form-item>       
            <el-form-item label="备注" >
                <el-input v-model="information.remark" size="small" :disabled="DisabledT"></el-input>
              </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
        <el-button @click="innerVisible = false">取 消</el-button>
        <el-button type="primary" @click="ChangeCore()">确 定 </el-button>
      </span>
      </el-dialog>
                  <div style="float:right;margin-left:50px">
                    <el-button type="primary" size="small" plain style="background: #246CE5;color:#fff;border-radius:9px;"
                              @click="addition()">添加
                    </el-button>
                  </div> 
        <div style="width:95%;margin-bottom:30px">
            <el-table tooltip-effect="light"  v-loading="loading" :data="tableData" style="width: 100%;height:400px;margin-bottom: 20px;margin-top:20px" row-key="id" border  :default-expand-all="false" :stripe="true" :tree-props="{children: 'children'}">
                <el-table-column show-overflow-tooltip prop="payName" label="支付配置名"></el-table-column>
                <el-table-column show-overflow-tooltip prop="appIdentifier" label="系统ID" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="payType" label="支付类型" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="businessType" label="业务类型" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="callbackUrl" label="回调接口" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="returnUrl" label="支付成功跳转地址" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="noticeUrl" label="通知接口" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="createTime" label="创建时间" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="updateTime" label="更新时间" ></el-table-column>
                <el-table-column show-overflow-tooltip prop="remark" label="备注" ></el-table-column>
                <el-table-column fixed="right" label="操作" width="160">
                    <template slot-scope="scope">
                        <el-button @click="Examine(scope.row)" type="primary" icon="el-icon-view" circle size="small"
                                    title="查看"></el-button>
                        <el-button @click="editMenu(scope.row)" type="primary" icon="el-icon-edit" circle size="small"
                                    title="修改"></el-button>
                        <el-button @click="delMenu(scope.row)" type="danger" icon="el-icon-delete" circle size="small"
                                    title="删除"></el-button>
                    </template>
                </el-table-column>
            </el-table>
              <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="float:right;">
    </el-pagination>
        </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="modification()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
 components: {},
  name: "PayConfig",
  data() {
    return {
        total:0,//默认数据总数
        pagesize:10,//每页的数据条数
        currentPage:1,//默认开始页面

        dialogVisible: false,
        loading:true,
        result:{},

        innerVisible:false,
        innerTitle:"",
        information:{},

        tableData:[],
        labelPosition:'right',
        DisabledT:false,
        DisabledTS:false,
        showDis:true,
        appIdentifier:"",

        PaymentTypeList:[],
        PaymentTypeValue:"",
        BusinessTypeList:[],
        BusinessTypeValue:"",


    };
  },
  watch:{
      dialogVisible(val){
          if(val == true){
              this.getAllMenu()
          }
      },
      // appIdentifier
      innerVisible(val){
        if(val == true){
          this.PaymentType()
          this.BusinessType()
          if(this.innerTitle == "添加支付配置"){
            this.information = {}
            this.appIdentifier = this.result.appIdentifier
          }else{
            this.appIdentifier = this.information.appIdentifier
          }
        }
      }
  },
  methods: {
    handleSizeChange(val) {
        this.pagesize  = val
        this.getAllMenu()
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.getAllMenu()
    },
    modification(){
        this.dialogVisible = false
    },
    ChangeCore(){
      if(this.innerTitle.indexOf("查看") != -1){
        this.innerVisible = false
      }else if(this.innerTitle.indexOf("修改") != -1){
        let obj = {
            "id": this.information.id,
            "payName": this.information.payName,
            "callbackUrl": this.information.callbackUrl,
            "returnUrl": this.information.returnUrl,
            "noticeUrl": this.information.noticeUrl,
            "remark": this.information.remark
          }
          this.$http.put(this.$requestUrl.PUT_PAY_CONFIG_UP,obj).then((res) => {
              let result = res.data;
            if (200 === result.code) {
              this.innerVisible = false
              this.getAllMenu()
                 this.$message({
                type: 'success',
                message: '修改成功!'
              });
            }else{
               this.$message({
                type: 'warning',
                message: '修改失败'
              });
            }
          }).catch(() => {
            this.$message.error(this.$errorMessage.SEVER_ERROR)
          })   
      }else{
        let obj = {
              "payName": this.information.payName,
              "appIdentifier":this.appIdentifier,
              "payType": this.PaymentTypeValue,
              "businessType": this.BusinessTypeValue,
              "callbackUrl": this.information.callbackUrl,
              "returnUrl": this.information.returnUrl,
              "noticeUrl": this.information.noticeUrl,
              "remark": this.information.remark
            }
            if(obj.payType == null || obj.payType == undefined){
                  this.$message({
                    type: 'warning',
                    message: '请选择支付类型'
                  });
            }else if(obj.businessType == null || obj.businessType == undefined){
                  this.$message({
                    type: 'warning',
                    message: '请选择业务类型'
                  });
            }else{
              this.$http.post(this.$requestUrl.POST_PAY_ADD,obj).then((res) => {
                  let result = res.data;
                if (200 === result.code) {
                  this.innerVisible = false
                  this.getAllMenu()
                    this.$message({
                    type: 'success',
                    message: '添加成功!'
                  });
                }else{
                  this.$message({
                    type: 'warning',
                    message: '添加失败'
                  });
                }
              }).catch(() => {
                this.$message.error(this.$errorMessage.SEVER_ERROR)
              })   
            }   
      }
    },
    handleClose(done) {
        this.dialogVisible = false
    },
    addition(){
      this.innerTitle = "添加支付配置"
      this.innerVisible = true
      this.DisabledT = false
      this.DisabledTS = false
      this.showDis = false
      this.PaymentTypeValue = ""
      this.BusinessTypeValue = ""

    },
    Examine(row){
      this.information = row
      this.innerTitle = "查看支付配置详情"
      this.innerVisible = true
      this.DisabledT = true
      this.DisabledTS = true
      this.allocation(row)
    },
    editMenu(row){
      this.information = row
      this.innerTitle = "修改支付配置"
      this.innerVisible = true
      this.DisabledT = false
      this.DisabledTS = true
      this.showDis = false
      this.allocation(row)
    },
    delMenu(row){
        this.$confirm('是否确认要删除该配置?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.delete(this.$requestUrl.DELETE_PAY_CONFIG+row.id).then((res) => {
              let result = res.data;
            if (200 === result.code) {
              this.getAllMenu()
                 this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }else{
               this.$message({
                type: 'warning',
                message: '删除失败'
              });
            }
          }).catch(() => {
            this.$message.error(this.$errorMessage.SEVER_ERROR)
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    getAllMenu() {
      let PageSize = {
        "page":this.currentPage, // 当前页
        "size":this.pagesize,  // 每页大小
        "appIdentifier":this.result.appIdentifier
      }
      this.$http.post(this.$requestUrl.POST_PAY_CONFIG_LIST,PageSize).then((res) => {
        let result = res.data;
        if (200 === result.code) {
          this.total = result.data.total
          this.tableData = result.data.records;
          this.loading=false
        } else {
          this.$message.error(result.msg)
          this.loading = false
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
        this.loading = false
      })
    },
    ChangePay(val){},
    ChangeBus(val){},
    PaymentType(){
      let obj = {
        "type": "pay_config_pay_type",
        "delFlag": "0"
      }
      this.$http.post(this.$requestUrl.POST_SYS_CONFIG_TYPE,obj).then((res) => {
        let result = res.data;
        if (200 === result.code) {
          this.PaymentTypeList = res.data.data
        } else {
          this.$message.error(result.msg)
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
    },
    BusinessType(){
        let obj = {
          "type": "pay_config_business_type",
          "delFlag": "0"
        }
      this.$http.post(this.$requestUrl.POST_SYS_CONFIG_TYPE,obj).then((res) => {
        let result = res.data;
        if (200 === result.code) {
          this.BusinessTypeList = res.data.data
        } else {
          this.$message.error(result.msg)
        }
      }).catch(() => {
        this.$message.error(this.$errorMessage.SEVER_ERROR)
      })
    },
    allocation(row){
      let that = this
      setTimeout(function(){
        for(let val of that.PaymentTypeList){
          if(val.label == row.payType){
            that.PaymentTypeValue = val.value
          }
        }
        for(let val of that.BusinessTypeList){
          if(val.label == row.businessType){
            that.BusinessTypeValue = val.value
          }
        }
      },250)
    }
  },
  created() {

  },
  beforeMount() {
  
  },
}
</script>

<style scoped lang="scss"></style>